export class ContainerOccupancyEmptyFullRate
{
    public deviceId?:string
    public emptyOccupancyCount?:number
    public fullOccupancyCount?:number
    public emptyRate?:number
    public fullRate?:number
    public count?:number
    public address?:string
}
export class StartEndDate{
    startTime?:Date;
    endTime?:Date;
}